/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDatabaseCrossBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 5.47826C2 6.40075 2.87038 7.28546 4.41966 7.93776C5.96893 8.59006 8.07021 8.95652 10.2612 8.95652C12.4522 8.95652 14.5535 8.59006 16.1028 7.93776C17.6521 7.28546 18.5224 6.40075 18.5224 5.47826M2 5.47826C2 4.55577 2.87038 3.67106 4.41966 3.01876C5.96893 2.36646 8.07021 2 10.2612 2C12.4522 2 14.5535 2.36646 16.1028 3.01876C17.6521 3.67106 18.5224 4.55577 18.5224 5.47826M2 5.47826V16.7826C2 18.58 5.2384 20.0592 9.39162 20.2418M18.5224 5.47826V9.3913M10.2612 12.4339C5.69929 12.4339 2 10.8774 2 8.95567M8.95682 16.3035C5.01491 16.0426 2 14.6035 2 12.8696M13.093 20.4719C12.1145 19.4934 11.5648 18.1663 11.5648 16.7826C11.5648 15.3989 12.1145 14.0718 13.093 13.0934C14.0715 12.1149 15.3986 11.5652 16.7824 11.5652C18.1662 11.5652 19.4933 12.1149 20.4718 13.0934M13.093 20.4719C14.0715 21.4503 15.3986 22 16.7824 22C18.1662 22 19.4933 21.4503 20.4718 20.4719C21.4503 19.4934 22 18.1663 22 16.7826C22 15.3989 21.4503 14.0718 20.4718 13.0934M13.093 20.4719L20.4718 13.0934"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDatabaseCross = wrapIcon(SvgDatabaseCrossBase);
export default SvgDatabaseCross;
